import script from "./WaizmannWert.vue?vue&type=script&setup=true&lang=js"
export * from "./WaizmannWert.vue?vue&type=script&setup=true&lang=js"

import "./WaizmannWert.vue?vue&type=style&index=0&id=1227d041&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1227d041"]])

export default __exports__